export const FETCH_LIST_INVENTORIES_REQUESTED = 'FETCH_LIST_INVENTORIES_REQUESTED';
export const FETCH_LIST_INVENTORIES_SUCCEEDED = 'FETCH_LIST_INVENTORIES_SUCCEEDED';
export const MOVING_PRODUCT_LOCATION_REQUEST = 'MOVING_PRODUCT_LOCATION_REQUEST';
